import { ArrowBackOutlined, ArrowForwardOutlined } from '@mui/icons-material'
import { Box, Button, Grid, TableCell, TableContainer, Typography, styled } from '@mui/material'
import { MemoizedButtons } from './paginatedButtons'

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  overflowX: 'auto',
  [theme.breakpoints.down('md')]: {
    '& .MuiTableCell-root': {
      padding: '8px',
    },
  },
  maxWidth: '100vw',
}))

export const StyledTableHeader = styled(TableCell)(({ theme }) => ({
  fontWeight: 'semibold',
  fontSize: '12px',
  color: '#7B8A9E',
}))

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: '0.8rem 16px',
}))

export function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props
  const pageTotal = count > 0 ? Math.ceil(count / rowsPerPage) : 1

  const gotoPrev = (event) => {
    onPageChange(event, page - 1)
  }
  const gotoNext = (event) => {
    onPageChange(event, page + 1)
  }

  return (
    <Box sx={{ flexShrink: 0, textAlign: 'right' }}>
      <Button
        variant="outlined"
        onClick={gotoPrev}
        disabled={page === 0}
        aria-label="first page"
        sx={{
          color: '#465464',
          border: '1px solid #CBD2DB',
        }}
        startIcon={<ArrowBackOutlined />}
      >
        previous
      </Button>
      <MemoizedButtons pageTotal={pageTotal} onPageChange={onPageChange} />
      <Button
        variant="outlined"
        onClick={gotoNext}
        disabled={page >= pageTotal - 1}
        aria-label="last page"
        sx={{
          color: '#465464',
          border: '1px solid #CBD2DB',
        }}
        startIcon={<ArrowForwardOutlined />}
      >
        next
      </Button>
    </Box>
  )
}

export const ResponsiveGridBox = styled(Box)`
  // Mobile Screen
  grid-template-columns: repeat(3, auto);

  // Tablet
  @media (min-width: 768px) {
    grid-template-columns: repeat(5, auto);
  }

  // Desktop
  @media (min-width: 1024px) {
    grid-template-columns: repeat(9, auto);
  }
`

export const Appbox = styled('div')({
  backgroundColor: '#fff',
  border: '1px solid #C4CAF1',
  borderRadius: '8px',
  color: '#64768C',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'center',
  padding: '16px',
  textAlign: 'center',
  height: '92px',
  // width: '100%',
  gap: 2,
  // '@media (min-width: 1280px)': { width: '109px', height: '90px' },
  // '@media (max-width: 880px)': { width: '95px', height: '90px' },
  // '@media (max-width: 500px)': { width: '85px', height: '90px' },
  '&:hover': { boxShadow: '0px 3px 6px #00000029' },
})

export const StyledContainer = styled(Box)`
  background-color: rgba(241, 243, 246, 1);
  padding: 1em;
  min-height: fit-content;
`

export const StyledFilterButtonGrid = styled(Grid)`
  display: flex;
  min-width: fit-content;
  max-width: 100%;
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-start;
  gap: 1em;
  padding: 0px;
  & > * {
    background-color: white;
  }

  /* For Desktop screen */
  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
`

export const StyledFilters = styled(Grid)`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-block-start: 0.5em;
  gap: 1.5em;

  /* For Desktop screen */
  @media screen and (min-width: 1024px) {
    justify-content: flex-end;
    align-items: center;
  }
`

export const StatsNumber = styled(Typography)({
  color: '#3C4FB9',
  fontWeight: '600',
  fontSize: '34px',
  fontFamily: 'Roboto Slab',
})

export const StatsNumberContainer = styled('div')({
  height: '36px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

export const LabelContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
  whiteSpace: 'normal',
  maxWidth: '100%',
})
